module.exports = __webpack_public_path__ + "static/media/confirmation-icon@2x.ae2fccb7.png";